var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.708252 1.33313C0.708252 0.987952 0.988074 0.70813 1.33325 0.70813H14.6666C15.0118 0.70813 15.2916 0.987952 15.2916 1.33313C15.2916 1.67831 15.0118 1.95813 14.6666 1.95813H1.33325C0.988074 1.95813 0.708252 1.67831 0.708252 1.33313ZM0.708252 14.6665C0.708252 14.3213 0.988074 14.0415 1.33325 14.0415H14.6666C15.0118 14.0415 15.2916 14.3213 15.2916 14.6665C15.2916 15.0116 15.0118 15.2915 14.6666 15.2915H1.33325C0.988074 15.2915 0.708252 15.0116 0.708252 14.6665ZM3.62492 7.16646C3.62492 6.59117 4.09129 6.1248 4.66659 6.1248H11.3333C11.9085 6.1248 12.3749 6.59117 12.3749 7.16646V8.83313C12.3749 9.40843 11.9085 9.8748 11.3333 9.8748H4.66659C4.09129 9.8748 3.62492 9.40843 3.62492 8.83313V7.16646ZM4.66659 4.8748C3.40093 4.8748 2.37492 5.90081 2.37492 7.16646V8.83313C2.37492 10.0988 3.40093 11.1248 4.66659 11.1248H11.3333C12.5989 11.1248 13.6249 10.0988 13.6249 8.83313V7.16646C13.6249 5.90081 12.5989 4.8748 11.3333 4.8748H4.66659Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlign);
export default __webpack_public_path__ + "static/media/align.c1412ae3f8f9269c01d535e01523a44f.svg";
export { ForwardRef as ReactComponent };